import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, reset } from "../features/auth/authSlice";
import { useEffect } from "react";
import { useToast } from "../components/Toast";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";

function Login() {
  const toast = useToast();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;
  const { user, isError, message, isLoading } = useSelector((state) => {
    return state.auth;
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

    if (user) {
      navigate("/");
    }

    dispatch(reset());
  }, [message, isError, dispatch, user, navigate, toast]);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(login(formData));
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#0b0e14] py-12 px-4 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-1/4 -left-20 w-80 h-80 bg-cyan-500/10 rounded-full blur-[120px] animate-pulse pointer-events-none" />
      <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-purple-600/10 rounded-full blur-[120px] animate-pulse pointer-events-none" />

      <div className="w-full max-w-md relative z-10">
        {/* Terminal Header */}
        <div className="mb-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-500/10 border border-cyan-500/20 rounded-full text-[10px] font-black text-cyan-400 uppercase tracking-[0.3em] mb-4">
            <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-ping" />
            Security Gateway
          </div>
          <h2 className="text-4xl font-black text-white uppercase italic tracking-tighter">
            Player <span className="text-cyan-400">Login</span>
          </h2>
        </div>

        {/* Login Form Card */}
        <form
          className="bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-8 md:p-10 flex flex-col gap-6 shadow-2xl relative group"
          onSubmit={onSubmit}
        >
          {/* Cyber Accent Line */}
          <div className="absolute top-0 left-10 right-10 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" />

          <div className="flex flex-col gap-5 w-full">
            <div className="space-y-1">
              <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                Recruit Identifier
              </label>
              <input
                type="email"
                name="email"
                id="email"
                className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-cyan-500/40 transition-all font-medium"
                value={email}
                placeholder="EMAIL_ADDRESS"
                autoComplete="off"
                onChange={onChange}
              />
            </div>

            <div className="space-y-1">
              <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                Access Key
              </label>
              <input
                type="password"
                name="password"
                id="password"
                className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 transition-all font-medium"
                value={password}
                placeholder="••••••••"
                autoComplete="off"
                onChange={onChange}
              />
            </div>
          </div>

          <button
            type="submit"
            className="group relative w-full p-4 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-2xl text-white font-black uppercase tracking-widest text-sm hover:from-cyan-400 hover:to-purple-500 transition-all duration-300 shadow-lg shadow-cyan-500/20 active:scale-[0.98] disabled:opacity-50 overflow-hidden"
            disabled={isLoading}
          >
            <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
            <span className="relative flex justify-center items-center gap-2">
              {isLoading ? <Loader size="sm" /> : "Initialize Session"}
            </span>
          </button>

          <div className="mt-4 pt-6 border-t border-white/5 flex flex-col items-center gap-4 text-[11px]">
            <div className="flex items-center gap-2 text-gray-500 font-bold uppercase tracking-wider">
              <span>New Recruit?</span>
              <Link
                to="/register"
                className="text-cyan-400 hover:text-cyan-300 transition-colors underline decoration-cyan-500/30 underline-offset-4"
              >
                Register Registry
              </Link>
            </div>

            <p className="text-[9px] text-gray-700 font-medium uppercase tracking-[0.2em]">
              © 2026 GamerHub Security Protocol
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
